import { Callback } from "@types";


/**
 * Specify a function that should execute when the DOM is fully loaded.
 *
 * @param {Callback} callback A function to execute after the DOM is ready.
 *
 * @example
 * ```ts
 * import domReady from '@wordpress/dom-ready';
 *
 * onDomReady(function() {
 * 	// do something after DOM loads.
 * });
 * ```
 *
 * @return {void}
 */
export function onDomReady(callback: Callback): void {
    if (typeof document === 'undefined') {
        return;
    }

    // if `DOMContentLoaded` already fired, invoke immediately
    if (['complete', 'interactive'].includes(document.readyState)) {
        return callback();
    }

    document.addEventListener('DOMContentLoaded', callback);
}
